export const PROFILE_AVATAR_SIZE = 48;
